/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Address } from './address';

export interface DeckCompany {
  readonly id: string;
  readonly name: string;
  /**
   * company logo
   */
  readonly logo: string;
  readonly address: Address;
  readonly organization_number: string;
}
